module.exports = __webpack_public_path__ + "img/9788954619073.66665e48.jpg";